import * as d3Import from 'd3';
import React, { useEffect, useRef } from 'react';
import type { D3Props } from '../common-types';

/**
 * Props for a {@link D3Axis} component.
 */
export interface D3AxisProps extends D3Props {
  /**
   * Axis height.
   */
  h: number;
  /**
   * Axis created using d3.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  axis: any;
  /**
   * Axis type.
   */
  axisType: 'x' | 'y';
}

/**
 * D3Axis component for drawing an x- or y-axis using d3.
 *
 * @param properties a {@link D3AxisProps} object
 * @return the created {@link React.JSX.Element}
 * @constructor
 */
export function D3Axis({
  axis,
  axisType,
  h,
  d3: d3Prop,
  ...props
}: Readonly<D3AxisProps>): React.JSX.Element {
  const d3 = d3Prop ?? d3Import;
  if (!d3.select) {
    throw new Error(
      "Some required d3 dependencies are missing. Make sure that at least 'd3-select'is on the page and accessible by the D3Axis"
    );
  }

  const axisRef = useRef(null);
  useEffect(() => {
    d3.select?.(axisRef.current).call(axis);
  }, [axis, d3]);

  const translate = axisType == 'x' ? `translate(0,${h})` : `translate(-10, 0)`;
  return <g {...props} className="axis" transform={translate} ref={axisRef} />;
}
